<template>
    <div>
      <vue-loading
        background-color="rgba(0,0,0,0.0)"
        :active="loadingAdvance"
        color="#4F41A3"
        :width="30"
        :height="30"
        :is-full-page="false"
      />
      <div class="flex flex-col md:flex-row cursor-pointer">
        <div class="bg-white border border-gray-300 rounded hover:shadow-xl p-6 w-full">
          <div class="flex text-zt-primary-600 pb-4 text-lg">
            <zt-icon name="calendar-day" />
            <p class="pl-2">{{ $t("message.dashboard.requestSalaryAdvance") }}</p>
          </div>

          <div
            v-if="licenceMessage !== ''"
            :class="errorClass"
            class="alert-company border rounded border-0 flex py-6 px-4 mb-6"
          >
            <div class="flex justify-start items-center mr-4">
              <zt-icon :name="errorIcon" :class="errorIcon" class="info-icon mr-2" />
              <p class="text-zt-base font-normal self-center">
                {{ postResponseMessage }}
              </p>
            </div>
          </div>
          <div :key="formKey">
          <div class="mb-2">
            <div class="mb-4">
              <zt-autocomplete
                :label="$t('message.dashboard.colaboratorLabel')"
                :items="entries"
                v-model="requestUser"
                @search="(val) => searchApi(val)"
                apiSearch
                :searchCharacter="3"
                clearable
                noResultsText="No hay colaborador que coincidan con tu busqueda"
                outlined
                returnObject
                data-vs-autocomplete="approver"
                class="pl-2"
              ></zt-autocomplete>
            </div>
          </div>
          <div class="mb-4">
            <zt-input
              :label="$t('message.salaryAdvanceForm.amountLabel')"
              v-model="requestAmount"
              @keypress="isNumber"
              maxlength="9"
              outlined
            ></zt-input>
          </div>
          <div class="mb-4">
            <zt-input
              :label="$t('message.dashboard.salaryAdvance.advanceReason')"
              v-model="requestReason"
              outlined
            ></zt-input>
          </div>
          <div class="mb-4">
            <vc-date-picker
            class="mx-auto"
            v-model="date"
            color="indigo"
            data-vs-datepicker="salaryAdvanceDatePicker"
            ref="salaryDaypicker"
          ></vc-date-picker>
          <p class="my-2 text-sm">
            {{ $t("message.salaryAdvanceForm.dateRangePlannedDateRemember") }}
          </p>

            <zt-check-box
              v-if="allowsSalaryPaymentAdvance"
              data-vs-check-box="allowsSalaryPaymentAdvance"
              v-model="salaryPaymentAdvance"
              color="primary"
              value="1"
            >
              {{ $t("message.licenseComponent.licenseBox.registerAnticipatePayment") }}
            </zt-check-box>
          </div>
        </div>
          <div class="mb-2 w-full">
            <zt-button
              class="w-full"
              :disabled="!isFormValid || isSubmitting"
              @click="postRequest"
              >{{ $t("message.dashboard.salaryAdvance.btnTitle") }}</zt-button
            >
          </div>
          <div v-if="false"
            class="flex justify-end text-zt-primary-200 p-4 text-md cursor-pointer"
            @click="
              $router.push({
                name: 'payroll-menu',
              })
            "
            data-vs-button="toPendingApproval"
          >
            <p class="pl-2">{{ $t("message.dashboard.salaryAdvance.viewRequests") }}</p>
            <zt-icon name="angle-right" />
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Payroll from "@/apiClient/Payroll";
import Manager from '@/apiClient/Manager'

export default {
  name: "SalaryAdvanceToColaborator",
  data() {
    return {
      date: null,
      requestAmount: "",
      requestReason: "",
      loadingAdvance: false,
      requestUser: {},
      licenceMessage: "",
      licenses: {},
      isSubmitting: false,
      postResponseMessage: "",
      entries: [],
      allowsSalaryPaymentAdvance: false,
      salaryPaymentAdvance: false,
      licenceMessageMappings: {
        info: { class: "bg-certs-info", icon: "info" },
        error: { class: "bg-certs-error", icon: "exclamation-circle-solid" },
        warning: { class: "bg-certs-warning", icon: "warning-triangle-solid" },
        default: { class: "no-errors", icon: "default-message" },
      },
      formKey: Date.now(), 
    };
  },
  created() {
    this.payroll = new Payroll();
    this.manager = new Manager();
  
  },
  mounted() {
    const inputElement = document.querySelector("input.vc-border-gray-400");
    if (inputElement) {
      inputElement.classList.remove("vc-border-gray-400");
      inputElement.classList.add("vc-border-gray-500");
      inputElement.classList.add('text-zt-dark-300')
    }
    this.$refs.salaryDaypicker.$children[0].$el.value = 'Fecha prevista'
  },
  computed: {
    isFormValid() {
      return this.requestAmount && this.requestReason && this.date && this.requestUser.id;
    },
    dateSelected() {
      return moment(this.date).format("YYYY-MM-DD");
    },
    errorClass() {
      const licenceMessageMapping = this.licenceMessageMappings[this.licenceMessage];
      return licenceMessageMapping
        ? licenceMessageMapping.class
        : this.licenceMessageMappings.default.class;
    },
    errorIcon() {
      const licenceMessageMapping = this.licenceMessageMappings[this.licenceMessage];
      return licenceMessageMapping
        ? licenceMessageMapping.icon
        : this.licenceMessageMappings.default.icon;
    },

    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople;
    },
  },
  watch: {
    date(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          this.$refs.salaryDaypicker.$children[0].$el.setAttribute('placeholder', 'Fecha prevista');
        });
      }
    }
  },

  methods: {
    async postRequest() {
      if (this.isSubmitting) {
        return;
      }
      this.postResponseMessage = "";
      this.isSubmitting = true;
      this.loadingAdvance = true;
      try {
        const data = {
          amount: this.requestAmount,
          plannedDate: this.dateSelected,
          reason: this.requestReason,
          employeeId: this.requestUser.id,
        };
        const { amount, plannedDate, reason, employeeId } = data;

        await this.payroll.requestUserSalaryAdvance(
          amount,
          plannedDate,
          reason,
          employeeId
        );
       
        this.licenceMessage = "info";
        this.postResponseMessage =
          "La información se envío correctamente y espera aprobación";
      } catch (error) {
        this.postResponseMessage = this.customErrorMessges(error.response.data.codes);
        this.licenceMessage = "error";
      } finally {
        this.resetFormFields()
        this.isSubmitting = false;
        this.loadingAdvance = false;
      }
    },

    resetFormFields() {
      this.requestUser = {};
      this.requestAmount = "";
      this.requestReason = "";
      this.date = null;
      this.formKey = Date.now(); 

    },

    isNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
    customErrorMessges(errorResponse) {
      const processErrorCode = ({ code, message }) => {
        switch (true) {
          case code === "LICENSE_MANAGER_CREATE_ERROR":
            return message;
          case code === "SICHERN_PEOPLE_ABSENCE_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST":
            return this.$t(`message.errorReference.${code}`);
          case code === "SICHERN_PEOPLE_HOLIDAYS_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST":
            if (this.$t(`message.errorReference.${code}_${message}`)) {
              return this.$t(`message.errorReference.${code}_${message}`);
            }
            return this.$t(`message.errorReference.${code}`);
          case /^SICHERN_PEOPLE_[A-Z_]+$/.test(code):
            // Verificar si `message` tiene espacios
            if (/\s/.test(message)) {
              return this.$t(`message.errorReference.${code}`);
            }
            return this.$t(`message.errorReference.${code}_${message}`);
          default:
            return this.$t(`message.errorReference.${code}`);
        }
      };
      return errorResponse.map(processErrorCode)[0];
    },

    async searchApi(val) {
      if (val.length > 2) {
        this.salaryPaymentAdvance = false;
        this.allowsSalaryPaymentAdvance = false;
        const index = val.indexOf("(");
        try {
          if (index !== -1) {
            val = val.substring(0, index).trim();
          }
          const res = await this.manager.getTeamUsers(val);
          const entries = res.data.data;
          this.entries = entries.map((entry) => {
            let fullName = `${entry.name} (${entry.cuil})`;
            const text =
              fullName.length > this.descriptionLimit
                ? fullName.slice(0, this.descriptionLimit) + "..."
                : fullName;
            return { ...entry, text };
          });
        } catch (error) {
          this.entries = [];
        }
      }
    },
  }
};
</script>
<style scoped>
.bg-certs-info {
  background: #def3ff 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-color: #5b9cc2;
}
.bg-certs-info>p {
  color: #017eec !important;
  opacity: 1 !important;
}
.info-button {
  background: #def3ff 0% 0% no-repeat padding-box !important;
  opacity: 1;
}

.info-icon {
  border-radius: 50%;
  font-size: 1.2rem;
  padding-block: 0.23rem;
  max-width: 40px;
}

.zt-icon-info {
  color: #def3ff;
  background: #017eec;
}
.error-icon {
  color: #def3ff;
  background: #ec1101;
  border-radius: 50%;
  font-size: 1.2rem;
  padding-block: 0.23rem;
}
.zt-icon-exclamation-circle-solid {
  font-size: x-large;
  color: red;
}
.bg-certs-error>p {
  color: #ec1101 !important;
  opacity: 1 !important;
}
.bg-certs-error {
  background: #ffe2de 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-color: #ffe2de;
}
</style>
